import { gql } from '@apollo/client'

import { SIMPLE_USER_FRAGMENT } from '../../../common/graphql/fragments'

const REQUEST_MENU_CURATION_TASK_SCRAPING_REVIEW_MUTATION = gql`
  mutation requestMenuCurationTaskScrapingReviewMutation(
    $id: ID!
    $comment: String
  ) {
    requestMenuCurationTaskScrapingReview(id: $id, comment: $comment) {
      id
      taskStatus
      isAvailableForTierOne
      isAvailableForUnknownWordsCuration
      isAvailableForUnknownWordsQa
      isAvailableForCuration
      isAvailableForQa
      isAvailableForQc
      scrapingReviewComment
      scrapingReviewerComment
      scrapingClarificationComment
      isScrapingReviewDone

      assignedTierOneCurator {
        ...SimpleUserFragment
      }

      assignedCurator {
        ...SimpleUserFragment
      }

      assignedQa {
        ...SimpleUserFragment
      }

      assignedUnknownWordsCurator {
        ...SimpleUserFragment
      }

      assignedUnknownWordsQa {
        ...SimpleUserFragment
      }

      assignedQc {
        ...SimpleUserFragment
      }

      assignedScrapingReviewerUser {
        ...SimpleUserFragment
      }
    }
  }
  ${SIMPLE_USER_FRAGMENT}
`

export default REQUEST_MENU_CURATION_TASK_SCRAPING_REVIEW_MUTATION
